"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Table_1 = __importDefault(require("@material-ui/core/Table"));
var TableFooter_1 = __importDefault(require("@material-ui/core/TableFooter"));
var TableRow_1 = __importDefault(require("@material-ui/core/TableRow"));
var TablePagination_1 = __importDefault(require("@material-ui/core/TablePagination"));
var useStyles_1 = __importDefault(require("./useStyles"));
var DataGridPagination = function (props) {
    var totalCount = props.totalCount, rowsPerPage = props.rowsPerPage, onChangePage = props.onChangePage, page = props.page, onChangeRowsPerPage = props.onChangeRowsPerPage;
    var classes = (0, useStyles_1.default)();
    return (react_1.default.createElement(Table_1.default, null,
        react_1.default.createElement(TableFooter_1.default, null,
            react_1.default.createElement(TableRow_1.default, null,
                react_1.default.createElement(TablePagination_1.default, { count: totalCount, rowsPerPage: rowsPerPage, page: page, labelRowsPerPage: "", rowsPerPageOptions: [rowsPerPage], onPageChange: onChangePage, onChangeRowsPerPage: onChangeRowsPerPage, classes: {
                        root: classes.pagination,
                        actions: classes.paginationActions
                    } })))));
};
exports.default = DataGridPagination;
